<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid content-area h-100p overflow-y-auto px-2 px-sm-3 px-lg-4 advanced-search-outer">
        <div class="advanced-search-page">
            <!-- Page title + metrics (when service enabled) -->
            <div class="as-page-header">
                <!-- <div class="as-page-header-left">
                    <h1 class="as-page-title">Advanced Search</h1>
                    <p class="as-page-subtitle">Combine multiple selectors to perform deep correlation analysis across all sources.</p>
                </div> -->
            </div>

            <!-- Service Disabled Warning -->
            <div class="search-card-container py-2" *ngIf="isServiceDisabled">
                <div class="service-disabled-warning">
                    <div class="warning-icon">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <h2 class="warning-title">Search temporarily unavailable</h2>
                    <p class="warning-message">
                        We're experiencing a temporary service issue. You can still access and export your previous search history below.
                    </p>
                </div>
            </div>

            <!-- Main search card -->
            <div class="search-card-container py-2" *ngIf="!isServiceDisabled">
                <div class="as-search-hero">
                    <div class="as-hero-top">
                        <div class="as-hero-title-row">
                            <div class="as-hero-title-left">
                                <div class="as-hero-icon-wrap" aria-hidden="true">
                                    <i class="fas fa-binoculars"></i>
                                </div>
                                <h2 class="as-hero-title">Advanced Search</h2>
                            </div>
                            <div class="as-page-header-right">
                                <div class="as-metric-pills as-metric-pills-inline">
                                    <div class="credits-inline">
                                        <span class="credits-inline-label">Remaining:</span>
                                        <span class="credits-inline-value"><i class="fas fa-spinner fa-spin" *ngIf="creditsLoading" aria-hidden="true"></i><ng-container *ngIf="!creditsLoading">{{ availableCredits | creditsLabel }}</ng-container></span>
                                    </div>
                                </div>
                                <button type="button" class="buy-credits-btn" (click)="onBuyCreditsButtonClick()">
                                    <i class="fas fa-coins credits-icon"></i>
                                    Buy Credits
                                </button>
                            </div>
                        </div>
                        <div class="as-hero-desc-wrap">
                            <p class="as-hero-desc">Fill any combination of fields. More selectors mean tighter correlation and fewer false positives.</p>
                        </div>
                        <div class="restricted-alert as-restricted-pill" appRestrictedAccessWarning role="note">
                            <i class="fas fa-exclamation-circle alert-icon"></i>
                            <span class="alert-text">
                                <span class="alert-restricted">RESTRICTED ACCESS</span>
                                <span class="as-restricted-sep">•</span>
                                <span class="alert-authorized">Authorized Law Enforcement Use Only</span>
                            </span>
                        </div>
                    </div>

                    <div class="as-form-grid">
                        <div class="as-form-row">
                            <div class="as-field">
                                <label class="as-field-label"><i class="bi bi-person as-field-icon"></i> Name</label>
                                <input type="text" [(ngModel)]="searchName" class="as-input" placeholder="e.g., John Doe" maxlength="100">
                                <span class="as-field-hint">Supports partial matches</span>
                            </div>
                            <div class="as-field">
                                <label class="as-field-label"><i class="bi bi-telephone as-field-icon"></i> Phone</label>
                                <div class="as-phone-input-wrap">
                                    <input type="text" [(ngModel)]="searchPhone" class="as-input as-input-phone" placeholder="e.g., *69769 or 81254*" maxlength="50">
                                </div>
                                <span class="as-field-hint">Use * for wildcards</span>
                            </div>
                        </div>
                        <div class="as-form-row">
                            <div class="as-field">
                                <label class="as-field-label"><i class="bi bi-envelope as-field-icon"></i> Email</label>
                                <input type="email" [(ngModel)]="searchEmail" class="as-input" placeholder="e.g., *@gmail.com or John*" maxlength="255">
                                <span class="as-field-hint">Use * or ? for patterns</span>
                            </div>
                            <div class="as-field">
                                <label class="as-field-label"><i class="bi bi-geo-alt as-field-icon"></i> Address</label>
                                <input type="text" [(ngModel)]="searchAddress" class="as-input" placeholder="e.g., Hyderabad" maxlength="255">
                                <span class="as-field-hint">City or location</span>
                            </div>
                        </div>
                        <div class="as-form-row as-form-row--id">
                            <div class="as-field as-field--id">
                                <label class="as-field-label"><i class="bi bi-hash as-field-icon"></i> ID number</label>
                                <input type="text" [(ngModel)]="searchIdNumber" class="as-input" placeholder="e.g., *6666 or AB*12" maxlength="50">
                                <span class="as-field-hint">Aadhaar, PAN, SSN, etc.</span>
                            </div>
                        </div>
                    </div>

                    <div class="as-form-footer">
                        <div class="as-footer-meta">
                            <p class="as-selector-line"><strong>{{ filledSelectorCount }}</strong> of 5 selectors used</p>
                            <p class="as-credit-line" *ngIf="searchCreditCost != null">
                                {{ searchCreditCost }} {{ searchCreditCost === 1 ? 'credit' : 'credits' }} per query · refunded if no hits
                            </p>
                        </div>
                        <div class="as-footer-actions">
                            <button type="button" class="as-btn as-btn--clear" (click)="clearSearchInputs()">
                                <i class="bi bi-x-lg"></i> Clear
                            </button>
                            <button type="button" (click)="searchNameSubmit()" class="as-btn as-btn--search" [disabled]="isServiceDisabled">
                                <i class="fas fa-search"></i> Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loading-container" *ngIf="searchLoading || loadingRecentResults">
                <div class="spinner-border" role="status"></div>
                <p class="loading-text">Fetching results, please wait...</p>
            </div>

            <div class="container results-section as-results-section">
                <div class="card-body p-2 p-md-4">
                    <div class="results-topbar">
                        <div class="results-header">
                            <h3 class="results-title">Recent Advanced Searches</h3>
                            <p class="results-subtitle">Click any row to open the search report.</p>
                        </div>
                        <div class="results-controls">
                            <div class="filter-section">
                                <select class="filter-select" [(ngModel)]="selectedFilterType" (ngModelChange)="onFilterTypeChange()">
                                    <option *ngFor="let filterType of filterTypes" [value]="filterType.value">
                                        {{ filterType.label }}
                                    </option>
                                </select>
                                <div class="filter-input-container">
                                    <input *ngIf="selectedFilterType === 'name'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="nameFilter" (ngModelChange)="onNameFilterChange($event)">
                                    <input *ngIf="selectedFilterType === 'notes'" class="filter-input" type="text" placeholder="Search by content" [(ngModel)]="notesFilter" (ngModelChange)="onNotesFilterChange($event)">
                                    <div class="date-filter-group" *ngIf="selectedFilterType === 'date-added'">
                                        <input class="filter-input date-input" type="date" [(ngModel)]="startDateFilter" (ngModelChange)="onStartDateFilterChange($event)">
                                        <input class="filter-input date-input" type="date" [(ngModel)]="endDateFilter" (ngModelChange)="onEndDateFilterChange($event)">
                                    </div>
                                </div>
                            </div>
                            <div class="action-buttons">
                                <button class="action-btn delete-btn" (click)="onDeleteButtonClick()">
                                    <i class="fas fa-trash"></i>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="results-table-container as-results-table-container">
                        <table class="results-table as-results-table">
                            <colgroup>
                                <col class="col-checkbox">
                                <col class="col-name">
                                <col class="col-status">
                                <col class="col-date">
                                <col class="col-time">
                                <col class="col-notes">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="checkbox-column">
                                        <input type="checkbox" class="table-checkbox" [checked]="recentResultsSelectAll.isSelected" (change)="onRecentResultsSelectAllClick()">
                                    </th>
                                    <th class="name-column-header">Name</th>
                                    <th>Status</th>
                                    <th>Date Added</th>
                                    <th>Time</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="!searchLoading && !loadingRecentResults && (!recentResultsPaged?.length || recentResultsCount === 0)" class="no-data-row">
                                    <td colspan="6" class="no-data-cell">No results yet. Search using the input above</td>
                                </tr>
                                <tr *ngFor="let recentResultPaged of recentResultsPaged" class="table-row">
                                    <td class="checkbox-column">
                                        <input type="checkbox" class="table-checkbox" [checked]="recentResultPaged.isSelected" (click)="onRecentResultPagedClick($event, recentResultPaged)">
                                    </td>
                                    <td class="name-column" (click)="goToSearchResultPage(recentResultPaged)">
                                        {{ recentResultPaged.name || recentResultPaged.searched_name }}
                                    </td>
                                    <td class="status-column">
                                        <span
                                            class="status-badge"
                                            [class.status-completed]="isRecentRowComplete(recentResultPaged)"
                                            [class.status-refreshing]="isRecentRowRefreshing(recentResultPaged)"
                                            [class.status-pending]="!isRecentRowComplete(recentResultPaged) && !isRecentRowRefreshing(recentResultPaged)"
                                        >
                                            {{ getRecentRowStatusLabel(recentResultPaged) }}
                                        </span>
                                    </td>
                                    <td class="date-column">
                                        {{ recentResultPaged.created_on | date : 'MMM d, y' }}
                                    </td>
                                    <td class="time-column">
                                        {{ recentResultPaged.created_on | date : 'HH:mm:ss' }}
                                    </td>
                                    <td class="notes-column" [title]="recentResultPaged.notes || ''">{{ truncateToWords(recentResultPaged.notes) || 'Test notes will come here.' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-container">
                        <div class="pagination-info">
                            Showing {{ recentResultsPagedStartAndEnd.start }} of {{ recentResultsCount }} result
                        </div>
                        <div class="pagination-controls">
                            <app-paginator [totalItems]="recentResultsCount" [itemsPerPage]="recentResultsPerPage" [currentPage]="recentResultsCurrentPage" (pageChange)="onRecentResultsPageChange($event)">
                            </app-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>